import type { IMyHomeV2Schema } from '../../repositories/price-estimator/entities/card/MyHomeV2Schema';
import { getMyHomesList as _getMyHomesList } from '../../services/getMyHomesList';
import { IThunkApi } from '../../types/redux';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getMyHomesList = createAsyncThunk<IMyHomeV2Schema[], undefined, IThunkApi>(
  'getMyHomesList',
  async (_, _thunkApi) => {
    const { extra } = _thunkApi;

    const response = await _getMyHomesList(extra);

    return response;
  },
);
